/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Copy from 'DesignSystem/Copy/index'
import Expanded from './Expanded/index'
import Indicator from './Indicator/index'
import Name from './Name/index'
import React from 'react'
import Status from './Status/index'
import Time from './Time/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/CustomResource/Content",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  backgroundColor
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.100'
        })
let customResourceNoteValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'note',
})
  return (<React.Fragment
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-2-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
</div>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--btlr-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-12-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--sb-6-Z1Yf8zk': isHoveredManual ? "6px" : flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "6px" : "1px",'--sc-8-Z1Yf8zk': isHoveredManual ? "rgba(222, 226, 230, 1)" : flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "rgba(222, 226, 230, 1)" : "rgba(222, 226, 230, 1)",'--soy-7-Z1Yf8zk': isHoveredManual ? "1px" : flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "1px" : "1px",'--bc-3-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? dtColorsGreen400 : dtColorsNeutral400,'--ml-4-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-5-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-13-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-14-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-15-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? dtColorsGreen100 : backgroundColor,'--bblr-11-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-12-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? "0px" : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Expanded/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'Expanded/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Expanded/Content'))}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="Content.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--mr-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<Copy
  viewPath={`${viewPath}/Copy`}
 data="custom_resource.note"
 value={customResourceNoteValueData}
 text="Copy instructions"
/>
</div>
</div>
</div>
<Expanded
  viewPath={`${viewPath}/Expanded`}
/>
</div>
</div>
{children}
</React.Fragment>)
}